//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
let d=[[[0,"AutoStartBaseView",1,1],[0,"AutoStartViewCreation",1,0],[0,"BaseordrawingView",1,0],[0,"EnglishSheetTemplateLocation",1,0],[0,"Height",1,0],[0,"Length",1,0],[0,"MetricSheetTemplateLocation",1,0],[0,"Name",1,0],[0,"Number",1,0],[0,"Option",1,0],[0,"ProjectionAngle",1,0],[0,"Revision",1,0],[0,"ScaleDenominator",1,0],[0,"ScaleNumerator",1,0],[0,"SecondaryNumber",1,0],[0,"StandardEnglishScale",1,0],[0,"StandardMetricScale",1,0],[0,"Units",1,0]],[],[]];
SPLM.Drawings.DrawingSheetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DrawingSheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DrawingSheetBuilder.SheetOption = Object.freeze({
    "UseTemplate" : "UseTemplate", "StandardSize" : "StandardSize", "CustomSize" : "CustomSize"});

SPLM.Drawings.DrawingSheetBuilder.SheetStandardMetricScale = Object.freeze({
    "S501" : "S501", "S201" : "S201", "S101" : "S101", "S51" : "S51", "S21" : "S21", "S11" : "S11", "S12" : "S12", "S15" : "S15", "S110" : "S110", "S120" : "S120", "S150" : "S150", "S1100" : "S1100", "Custom" : "Custom"});

SPLM.Drawings.DrawingSheetBuilder.SheetStandardEnglishScale = Object.freeze({
    "S81" : "S81", "S41" : "S41", "S21" : "S21", "S11" : "S11", "S12" : "S12", "S14" : "S14", "S18" : "S18", "Custom" : "Custom"});

SPLM.Drawings.DrawingSheetBuilder.SheetUnits = Object.freeze({
    "Metric" : "Metric", "English" : "English"});

SPLM.Drawings.DrawingSheetBuilder.SheetProjectionAngle = Object.freeze({
    "First" : "First", "Third" : "Third"});

SPLM.Drawings.DrawingSheetBuilder.SheetMode = Object.freeze({
    "Create" : "Create", "Edit" : "Edit"});

SPLM.Drawings.DrawingSheetBuilder.SheetBaseordrawingView = Object.freeze({
    "Base" : "Base", "Drawing" : "Drawing"});

export default SPLM;